import { Table } from "semantic-ui-react";
import React from "react";
import { Link } from "react-router-dom";
import { useAuth, userActiveView } from "../../utils/Auth";
import AreaEditionAction from "./AreaEditionAction";

export const AreaTableRow = ({ area, reload, active }) => {
  const { user } = useAuth();
  return (
    <Table.Row>
      <Table.Cell>{area.code}</Table.Cell>
      <Table.Cell>
        <Link to={`/areas/${area.id}/funcionarios`}>{area.name}</Link>
      </Table.Cell>
      <Table.Cell>
        {area.parent_info ? (
          <Link to={`/areas/${area.parent_info.id}/funcionarios`}>
            {area.parent_info.name}
          </Link>
        ) : (
          "-"
        )}
      </Table.Cell>
      <Table.Cell>{area.employee_count}</Table.Cell>
      <Table.Cell textAlign={"center"}>
        {userActiveView(user) && area.current_record && active && (
          <AreaEditionAction area={area} reload={reload} />
        )}
      </Table.Cell>
    </Table.Row>
  );
};
//{
